/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="abcb1356-16d3-43b3-a02f-238872cb2270" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="bcea5bd0-990e-4d42-805f-5c5ad54605c6" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
      <g id="ab5e3d39-5871-4a62-809a-3b156d8de3b7">
        <path id="b08068b6-e59e-4e03-9092-f5914838c074" d="M5,8.74c0,6.74,6.16,11.8,6.43,12l.31.25.32-.25c.26-.21,6.4-5.26,6.4-11.94A6.66,6.66,0,0,0,11.71,2,6.51,6.51,0,0,0,6.78,4.06,6.85,6.85,0,0,0,5,8.74ZM11.71,3V3a5.67,5.67,0,0,1,5.75,5.82c0,5.37-4.56,9.83-5.72,10.88C10.57,18.65,6,14.19,6,8.74a5.87,5.87,0,0,1,1.51-4A5.55,5.55,0,0,1,11.71,3Zm0,9.12A3.14,3.14,0,1,0,8.62,9a3.14,3.14,0,0,0,3.13,3.14Zm0-5.27A2.14,2.14,0,1,1,9.62,9,2.13,2.13,0,0,1,11.75,6.85Z" style={{fill: "#fff",fillRule: "evenodd"}}/>
      </g>
    </mask>
  </defs>
  <g id="b797729b-3b9c-45b6-82a7-de034fc16e45">
    <g id="ba3436a3-66a8-4f1f-83da-bc957c1bf31e">
      <g id="b42f9a45-baeb-43c0-bccd-e1522ee78db3">
        <path id="ad34e110-3768-4f8e-bdf1-2132c535d92c" d="M5,8.74c0,6.74,6.16,11.8,6.43,12l.31.25.32-.25c.26-.21,6.4-5.26,6.4-11.94A6.66,6.66,0,0,0,11.71,2,6.51,6.51,0,0,0,6.78,4.06,6.85,6.85,0,0,0,5,8.74ZM11.71,3V3a5.67,5.67,0,0,1,5.75,5.82c0,5.37-4.56,9.83-5.72,10.88C10.57,18.65,6,14.19,6,8.74a5.87,5.87,0,0,1,1.51-4A5.55,5.55,0,0,1,11.71,3Zm0,9.12A3.14,3.14,0,1,0,8.62,9a3.14,3.14,0,0,0,3.13,3.14Zm0-5.27A2.14,2.14,0,1,1,9.62,9,2.13,2.13,0,0,1,11.75,6.85Z" style={{fill: "#05273e"}} className="icon-fill"/>
      </g>
      <g style={{mask: "url(#bcea5bd0-990e-4d42-805f-5c5ad54605c6)"}}>
        <g id="be157d56-2c02-46a1-97c7-fc4afd4a91de">
          <rect id="b67193af-8a2a-48e0-93a6-37d0966c72a6" width="24" height="24" style={{fill: "#002b49"}} className="icon-fill"/>
        </g>
      </g>
      <g style={{mask: "url(#bcea5bd0-990e-4d42-805f-5c5ad54605c6)"}}>
        <rect id="fefa5517-2eab-4a28-b2e5-6ffeaf51fc5d" width="24" height="24" style={{fill: "#1570bc"}} className="icon-fill"/>
      </g>
    </g>
  </g>
</svg>

    );
  }
}

Icon.displayName = 'MapPinIcon';

export default Icon;
